export const createIsSecureContext = (window) => (window !== null && window.isSecureContext);
